import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

export interface IPrivateRouteProps {
  allowedModules?: Array<any>;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ allowedModules }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { idUsuario, modules } = useSelector((state: any) => state.user);

  const applieValidateModules = React.useCallback(
    (modules: Array<any>, routeStr: string): boolean => {
      for (const m of modules) {
        if (routeStr.includes(m.url) || routeStr.includes(m?.idVista)) {
          return true;
        }
        if (m.hijos && applieValidateModules(m.hijos, routeStr)) {
          return true;
        }
      }
      return false;
    },
    []
  );

  React.useEffect(() => {

    if (!idUsuario || !modules) {
      dispatch({ type: "LOGOUT" });
    }
  }, [idUsuario, modules, dispatch]);

  const verify = React.useCallback((): boolean => {
    if (!idUsuario || !modules) {
      return false;
    }

    const routeStr: string = location.pathname;
    if (["/profile", "/inicio"].includes(routeStr)) {
      return true;
    }

    return applieValidateModules(modules, routeStr);
  }, [idUsuario, modules, location.pathname, applieValidateModules]);

  if (!verify()) {
    // Redirige al usuario al login si no está autenticado
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

export default PrivateRoute;
